import { createSlice } from "@reduxjs/toolkit";

const modalDirtySlice = createSlice({
    name: "modalDirty",
    initialState: {
        byKey: {}, // { [key]: boolean } // because if user opens multiple modals, we need to track each modal's dirty state separately
    },
    reducers: {
    setModalDirty(state, action) {
        const { key, dirty } = action.payload;
        state.byKey[key] = !!dirty;
    },
    clearModalDirty(state, action) {
        delete state.byKey[action.payload];
        },
    },
});

export const { setModalDirty, clearModalDirty } = modalDirtySlice.actions;
export default modalDirtySlice.reducer;

export const selectDirtyByKey = (state, key) => Boolean(state.modalDirty.byKey[key]);
